import {
    Modal, Table, Button,
} from 'appkit-react';

const FFIEC009ResultReportModal = ({
    setShowResultReportModal, resultData,
}) => {
    /** Column configuration */
    const columns = [{
        Header: 'Rule Description',
        accessor: 'ruleDescription',
        minWidth: 170,
        style: { whiteSpace: 'unset' },
    }, {
        Header: 'Rule Condition',
        accessor: 'ruleCondition',
        minWidth: 100,
        style: { whiteSpace: 'unset' },
    }, {
        Header: 'Result',
        accessor: 'result',
        minWidth: 80,
    },
    ];

    return (
        <Modal
            className="form-modal true-comply-rules__result-report-modal"
            visible
        >
            <div className="true-comply-rules__result-report-modal-headsection">
                <p>RESULT REPORT</p>
                <span onClick={() => setShowResultReportModal(false)} className="appkiticon icon-close-outline" aria-hidden="true" />
            </div>
            <div className="true-comply-rules__result-report-modal-bodysection">
                <Table
                    data={resultData}
                    columns={columns}
                    showPageSizeOptions={false}
                    striped
                    defaultPageSize={8}
                    sortable={false}
                    resizable
                    noDataText="No Failed Data ..!!!"
                />
            </div>
            <div className="true-comply-rules__result-report-modal-footersection">
                <Button size="lg" onClick={() => setShowResultReportModal(false)} aria-hidden="true">OK</Button>
            </div>
        </Modal>
    );
};

export default FFIEC009ResultReportModal;
